"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteUrlsProvider = exports.useSiteUrls = exports.SiteUrlsContext = exports.noopSiteUrls = void 0;
const tslib_1 = require("tslib");
const shared_urls_1 = require("@tableau/shared-urls");
const react_1 = tslib_1.__importDefault(require("react"));
exports.noopSiteUrls = new shared_urls_1.SiteUrls({ siteUrlName: '' });
exports.SiteUrlsContext = react_1.default.createContext(new shared_urls_1.SiteUrls({ siteUrlName: '' }));
function useSiteUrls() {
    return react_1.default.useContext(exports.SiteUrlsContext);
}
exports.useSiteUrls = useSiteUrls;
function SiteUrlsProvider(props) {
    return (react_1.default.createElement(exports.SiteUrlsContext.Provider, { value: props.value }, props.children));
}
exports.SiteUrlsProvider = SiteUrlsProvider;
//# sourceMappingURL=SiteUrlsContext.js.map